import { atom } from "recoil";

const FlightByDestinationListActiveAtom = atom<boolean>({
    
    key: 'flightByDestinationActiveList',
    default: false
})

export default FlightByDestinationListActiveAtom;